/**
 * Runtime app config provided by the composition root (apps/web/main.tsx),
 * which is the one place platform/env branching is allowed. Keeps feedback
 * (the app's only network call) out of the file-source abstraction.
 */
export interface AppConfig {
  /** Where the feedback form POSTs: same-origin `/api/feedback` on web, the
   *  absolute deployed endpoint on native (which has no local server). */
  readonly feedbackEndpoint: string;
  /** Turnstile site key for the feedback form; '' disables Turnstile (native). */
  readonly turnstileSiteKey: string;
}

export const DEFAULT_APP_CONFIG: AppConfig = {
  feedbackEndpoint: '/api/feedback',
  turnstileSiteKey: '',
};
